/* TWS Header — mobile "top sheet" (Option C). Static asset; drives every .twsh
   instance. Mobile accordions + icons are built from the live desktop nav so
   the mega-menu content is the single source of truth. */
(function () {
  function initHeader(root) {
    var nav = root.querySelector('nav.twsnav');
    var burger = root.querySelector('.burger');
    var scrim = root.querySelector('[data-scrim]');
    var sheet = root.querySelector('.sheet');
    if (!nav || !burger || !scrim || !sheet) return;
    var sheetBody = sheet.querySelector('.sheet-body');
    var body = document.body;

    function firstText(el) {
      var top = el.querySelector(':scope > .nav-top');   // Shop's label is a link
      if (top) return top.textContent.trim();
      var n = el.firstChild;
      return (n && n.nodeType === 3) ? n.textContent.trim() : el.textContent.trim();
    }

    root.querySelectorAll('.nav-links > .navitem').forEach(function (item) {
      var mega = item.querySelector('.mega');
      if (!mega) {
        var a = document.createElement('a');
        a.className = 'mlink';
        a.href = item.getAttribute('href') || '#';
        a.textContent = firstText(item);
        sheetBody.appendChild(a);
        return;
      }
      var acc = document.createElement('div'); acc.className = 'macc';
      var btn = document.createElement('button');
      btn.className = 'mtrigger'; btn.type = 'button'; btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span>' + firstText(item) + '</span><svg class="chev" viewBox="0 0 14 14"><path d="M3 5l4 4 4-4"/></svg>';
      var panel = document.createElement('div'); panel.className = 'mpanel';
      var pin = document.createElement('div'); pin.className = 'mpanel-in';
      mega.querySelectorAll('.col').forEach(function (col) {
        var c = document.createElement('div'); c.className = 'mcol';
        var h = col.querySelector('h5');
        if (h) { var mh = document.createElement('h5'); mh.textContent = h.textContent; c.appendChild(mh); }
        col.querySelectorAll('a').forEach(function (l) {
          var la = document.createElement('a'); la.href = l.getAttribute('href') || '#'; la.textContent = l.textContent; c.appendChild(la);
        });
        pin.appendChild(c);
      });
      panel.appendChild(pin); acc.appendChild(btn); acc.appendChild(panel);
      btn.addEventListener('click', function () {
        var willOpen = !acc.classList.contains('open');
        sheetBody.querySelectorAll('.macc.open').forEach(function (o) {
          o.classList.remove('open');
          o.querySelector('.mpanel').style.maxHeight = '0px';
          o.querySelector('.mtrigger').setAttribute('aria-expanded', 'false');
        });
        if (willOpen) { acc.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); panel.style.maxHeight = pin.scrollHeight + 'px'; }
      });
      sheetBody.appendChild(acc);
    });

    // Desktop: flag <body> while any mega-menu is hovered open, so the meta-bar
    // strip can hide itself (body.twsh-mega-open). :hover is read live so moving
    // between adjacent megas or onto a plain item resolves correctly, no flicker.
    var navLinks = root.querySelector('.nav-links');
    if (navLinks) {
      var syncMega = function () {
        body.classList.toggle('twsh-mega-open', !!navLinks.querySelector('.has-mega:hover, .has-mega.is-open'));
      };
      navLinks.addEventListener('mouseover', syncMega);
      navLinks.addEventListener('mouseout', syncMega);

      // ---- Desktop mega-menu: hold it open ----
      // The panel was pure CSS :hover. The trigger is only the label; below it
      // sits the nav's own padding, which belongs to neither the label nor the
      // panel — so moving diagonally rather than straight down crossed dead
      // ground, :hover flipped, and the menu shut mid-movement.
      //
      // pointerenter/pointerleave on .has-mega already treat the panel as part
      // of the item (it is a DOM descendant, wherever it is painted), so the only
      // thing missing was tolerance for that dead ground: leaving starts a short
      // timer, re-entering cancels it. CSS still opens on :hover, so with JS off
      // the original behaviour survives.
      var GRACE = 260, holdTimer = null, holdOpen = null;
      var megaItems = navLinks.querySelectorAll('.navitem.has-mega');
      var cancelHold = function () { if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; } };
      var shutItem = function (item) {
        if (item) item.classList.remove('is-open');
        if (holdOpen === item) holdOpen = null;
        syncMega();
      };
      Array.prototype.forEach.call(megaItems, function (item) {
        item.addEventListener('pointerenter', function () {
          cancelHold();
          if (holdOpen && holdOpen !== item) shutItem(holdOpen);   // switching is instant
          item.classList.add('is-open');
          holdOpen = item;
          syncMega();
        });
        item.addEventListener('pointerleave', function () {
          cancelHold();
          holdTimer = setTimeout(function () { shutItem(item); holdTimer = null; }, GRACE);
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          cancelHold();
          Array.prototype.forEach.call(megaItems, function (i) { i.classList.remove('is-open'); });
          holdOpen = null;
          syncMega();
        }
      });

    }

    var ico = root.querySelector('.nav-ico');
    if (ico) sheetBody.appendChild(ico.cloneNode(true));

    function clearHeader() { sheetBody.style.paddingTop = (nav.getBoundingClientRect().bottom + 10) + 'px'; }
    clearHeader();
    window.addEventListener('resize', clearHeader, { passive: true });

    function openM() {
      reveal();          /* clearHeader() measures nav's underside — untuck first */
      clearHeader();
      root.classList.add('nav-open'); body.classList.add('twsh-locked');
      burger.setAttribute('aria-expanded', 'true'); burger.setAttribute('aria-label', 'Close menu');
    }
    function closeM() {
      root.classList.remove('nav-open'); body.classList.remove('twsh-locked');
      burger.setAttribute('aria-expanded', 'false'); burger.setAttribute('aria-label', 'Open menu');
      sheet.querySelectorAll('.macc.open').forEach(function (a) {
        a.classList.remove('open');
        a.querySelector('.mpanel').style.maxHeight = '0px';
        a.querySelector('.mtrigger').setAttribute('aria-expanded', 'false');
      });
    }
    /* ── Reveal on scroll up ───────────────────────────────────────────────
       Shopify's own name for this is "sticky header: on scroll up"; the
       pattern is widely called "headroom". Tuck the bar away going down,
       bring it straight back on the smallest upward move.

       ⚠ WHETHER THE BAR IS STICKY IS A RUNTIME QUESTION, NOT A SETTING ONE.
       On desktop it is sticky only when the "Sticky header" checkbox is on,
       but the MOBILE bar is sticky unconditionally, from a media query baked
       into the section. Reading the computed position covers both without
       duplicating that rule here — and it re-evaluates for free on resize. */
    var REVEAL = root.hasAttribute('data-reveal-on-scroll-up');
    var JITTER = 4;     /* trackpads emit 1-2px noise; 4px still reads as instant */
    var ARM_AT = 140;   /* never tuck while still near the top of the page */
    var lastY = Math.max(0, window.pageYOffset), tucked = false, queued = false;
    /* The state class goes on the SECTION WRAPPER: that is the element that is
       actually sticky, and the one whose empty band has to stop taking clicks
       once the bar has slid out of it. */
    var shell = root.closest('.tws-header-section') || root;

    function isSticky() {
      return getComputedStyle(shell).position === 'sticky';
    }
    /* Anything that would be absurd to yank off-screen mid-interaction. */
    function busy() {
      return root.classList.contains('nav-open') ||                 /* mobile sheet */
             !!root.querySelector('.has-mega.is-open') ||           /* mega held open */
             !!root.querySelector('.navitem.has-mega:hover') ||     /* mega on hover */
             !!document.querySelector('.twsq-panel.is-open') ||     /* search panel */
             root.contains(document.activeElement);                 /* keyboard is in here */
    }
    function tuck(on) {
      if (tucked === on) return;
      tucked = on;
      shell.classList.toggle('is-tucked', on);
    }
    function reveal() { tuck(false); }

    function onScrollFrame() {
      queued = false;
      var y = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
      var dy = y - lastY;
      /* Below the jitter floor, leave lastY alone so slow scrolls still
         accumulate to a real gesture instead of being swallowed. */
      if (dy < JITTER && dy > -JITTER) return;
      lastY = y;
      if (!REVEAL || !isSticky() || y <= ARM_AT || busy()) { reveal(); return; }
      tuck(dy > 0);
    }
    window.addEventListener('scroll', function () {
      if (!queued) { queued = true; window.requestAnimationFrame(onScrollFrame); }
    }, { passive: true });

    /* Anything that needs the bar in view can ask for it — the search panel
       measures the bar's underside to place itself, and "/" can be pressed
       while the bar is tucked. */
    document.addEventListener('tws:reveal-header', reveal);

    burger.addEventListener('click', function () { root.classList.contains('nav-open') ? closeM() : openM(); });
    scrim.addEventListener('click', closeM);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeM(); });
    sheetBody.addEventListener('click', function (e) { if (e.target.closest('a')) closeM(); });
  }

  function boot() { document.querySelectorAll('.twsh').forEach(initHeader); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
